export default __webpack_public_path__ + "static/media/Ies_NombreSeminarioHOME_MOVIL.89edc03e.png";